import React from 'react';
import {BrowserRouter, Redirect, Route, Switch} from "react-router-dom";
import {inject, observer} from "mobx-react";
import FeedbackIndex from "../../components/feedback";
import BookingRoomPageIndex from "../../components/booking/room";
import BookingStudioPageIndex from "../../components/booking/studio";
import IndexPage from "../../components/index";
import BookingHistoryIndex from "../../components/booking/history";
import UserCabinetIndexPage from "../../components/cabinet";
import withRouterStore from "./store";
import AuthModal from "../../components/shared/auth_modal";
import AuthPage from "../../components/auth";
import Slots from "../../components/slots";
import Error404 from "../../components/shared/404";
import PwaHandler from "../../components/shared/pwa_handler";


let isAuth = null;

const AuthRoute = ({component: Component, ...rest}) => {
    if (!isAuth && rest.path !== '/booking/auth') {
        return <Redirect to="/booking/auth"/>
    }
    return <Route {...rest} component={Component}/>
};


@inject("authStore", "routerStore")
@observer
class MainRouter extends React.Component {
    render() {
        isAuth = this.props.authStore.checkAuth();

        return (
            <div>
                <PwaHandler/>
                <AuthModal/>
                <BrowserRouter>
                    <Switch>
                        <Route exact path='/' component={IndexPage}/>
                        {/*Роуты для приложения */}
                        <Route path='/appointments/slots' component={Slots}/>
                        <Route path='/booking/history'
                               component={withRouterStore(this.props.routerStore)(BookingHistoryIndex)}/>
                        {/*Роуты для веба*/}
                        <AuthRoute path='/booking/cabinet'
                                   component={withRouterStore(this.props.routerStore)(UserCabinetIndexPage)}/>
                        <AuthRoute path='/booking/auth'
                                   component={withRouterStore(this.props.routerStore)(AuthPage)}/>
                        <Route path='/booking/:serviceType/room/:roomId'
                               component={withRouterStore(this.props.routerStore)(BookingRoomPageIndex)}/>
                        <Route path='/booking/:serviceType/studio/:studioId'
                               component={withRouterStore(this.props.routerStore)(BookingStudioPageIndex)}/>
                        <Route path='/booking/:roomId'
                               component={withRouterStore(this.props.routerStore)(BookingRoomPageIndex)}/>
                        <Route path='/feedback/:roomId' component={FeedbackIndex}/>
                        <Route component={Error404}/>
                    </Switch>
                </BrowserRouter>
            </div>
        )
    }
}

export default MainRouter;
